import { render, staticRenderFns } from "./BannerListEdit.vue?vue&type=template&id=b6f99f10&scoped=true"
import script from "./BannerListEdit.vue?vue&type=script&lang=js"
export * from "./BannerListEdit.vue?vue&type=script&lang=js"
import style0 from "./BannerListEdit.vue?vue&type=style&index=0&id=b6f99f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f99f10",
  null
  
)

export default component.exports